import { supabase } from './supabase';

// Balance Sheet Operations
export const getBalanceSheetItems = async () => {
  try {
    console.log('Fetching balance sheet items...');
    const { data, error } = await supabase
      .from('balance_sheet')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching balance sheet items:', error);
      throw error;
    }
    console.log('Successfully fetched balance sheet items:', data);
    return data;
  } catch (error) {
    console.error('Error in getBalanceSheetItems:', error);
    throw error;
  }
};

export const addBalanceSheetItem = async (item) => {
  try {
    console.log('Adding balance sheet item:', item);
    const user = await supabase.auth.getUser();
    console.log('Current user:', user);
    
    const { data, error } = await supabase
      .from('balance_sheet')
      .insert([
        {
          ...item,
          user_id: user.data.user.id
        }
      ])
      .select();

    if (error) {
      console.error('Error adding balance sheet item:', error);
      throw error;
    }
    console.log('Successfully added balance sheet item:', data);
    return data[0];
  } catch (error) {
    console.error('Error in addBalanceSheetItem:', error);
    throw error;
  }
};

export const updateBalanceSheetItem = async (id, item) => {
  try {
    console.log('Updating balance sheet item:', { id, item });
    const { data, error } = await supabase
      .from('balance_sheet')
      .update(item)
      .eq('id', id)
      .select();

    if (error) {
      console.error('Error updating balance sheet item:', error);
      throw error;
    }
    console.log('Successfully updated balance sheet item:', data);
    return data[0];
  } catch (error) {
    console.error('Error in updateBalanceSheetItem:', error);
    throw error;
  }
};

export const deleteBalanceSheetItem = async (id) => {
  try {
    console.log('Deleting balance sheet item:', id);
    const { error } = await supabase
      .from('balance_sheet')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting balance sheet item:', error);
      throw error;
    }
    console.log('Successfully deleted balance sheet item');
  } catch (error) {
    console.error('Error in deleteBalanceSheetItem:', error);
    throw error;
  }
};

// Cash Flow Operations
export const getCashFlowItems = async () => {
  try {
    console.log('Fetching cash flow items...');
    const { data, error } = await supabase
      .from('cash_flow')
      .select('*')
      .order('date', { ascending: false });

    if (error) {
      console.error('Error fetching cash flow items:', error);
      throw error;
    }
    console.log('Successfully fetched cash flow items:', data);
    return data;
  } catch (error) {
    console.error('Error in getCashFlowItems:', error);
    throw error;
  }
};

export const addCashFlowItem = async (item) => {
  try {
    console.log('Adding cash flow item:', item);
    const user = await supabase.auth.getUser();
    console.log('Current user:', user);
    
    const { data, error } = await supabase
      .from('cash_flow')
      .insert([
        {
          ...item,
          user_id: user.data.user.id
        }
      ])
      .select();

    if (error) {
      console.error('Error adding cash flow item:', error);
      throw error;
    }
    console.log('Successfully added cash flow item:', data);
    return data[0];
  } catch (error) {
    console.error('Error in addCashFlowItem:', error);
    throw error;
  }
};

export const updateCashFlowItem = async (id, item) => {
  try {
    console.log('Updating cash flow item:', { id, item });
    const { data, error } = await supabase
      .from('cash_flow')
      .update(item)
      .eq('id', id)
      .select();

    if (error) {
      console.error('Error updating cash flow item:', error);
      throw error;
    }
    console.log('Successfully updated cash flow item:', data);
    return data[0];
  } catch (error) {
    console.error('Error in updateCashFlowItem:', error);
    throw error;
  }
};

export const deleteCashFlowItem = async (id) => {
  try {
    console.log('Deleting cash flow item:', id);
    const { error } = await supabase
      .from('cash_flow')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting cash flow item:', error);
      throw error;
    }
    console.log('Successfully deleted cash flow item');
  } catch (error) {
    console.error('Error in deleteCashFlowItem:', error);
    throw error;
  }
};

// User Profile Operations
export const getUserProfile = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No user found');

    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('user_id', user.id)
      .single();

    if (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
    return data;
  } catch (error) {
    console.error('Error in getUserProfile:', error);
    throw error;
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('No user found');

    const { data, error } = await supabase
      .from('user_profiles')
      .upsert({
        user_id: user.id,
        ...profileData,
        updated_at: new Date().toISOString(),
      })
      .select()
      .single();

    if (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
    return data;
  } catch (error) {
    console.error('Error in updateUserProfile:', error);
    throw error;
  }
}; 